import i18n from "@/i18n";


export const fmtMoney = (n, currency = "EUR") => {
  const cur = (currency || "EUR").toUpperCase();
  try {
    return new Intl.NumberFormat("es-ES", { style: "currency", currency: cur }).format(Number(n || 0));
  } catch {
    return `${cur} ${Number(n || 0).toLocaleString("es-ES", { minimumFractionDigits: 2 })}`;
  }
};

export const fmtEur = (n) => fmtMoney(n, "EUR");

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export const groupIban = (iban) =>
  (iban || "").replace(/\s+/g, "").replace(/(.{4})/g, "$1 ").trim();

export const transferTypeLabel = (type) => i18n.t(`tx.type.${type}`, { defaultValue: type });
